// src/pages/ProfileEdit/editProfileTourConfig.js

export const editProfileTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur l\'Édition de Profil',
            description: 'Je vais vous guider à travers toutes les sections pour modifier vos informations personnelles et médicales.',
            side: 'over',
        },
    },
    {
        element: '.pe-grid',
        popover: {
            title: '✏️ Page d\'Édition',
            description: 'Cette page vous permet de mettre à jour toutes vos informations : profil, historique médical et assurance.',
            position: 'center',
        },
    },
    {
        element: '.profile-edit__sidebar',
        popover: {
            title: '👤 Carte de Profil',
            description: 'Votre photo de profil et vos informations de base. Cliquez sur l\'icône de modification pour changer votre photo.',
            position: 'right',
        },
    },
    {
        element: '.pe-title-link',
        popover: {
            title: '📝 Titre de la Page',
            description: 'Vous êtes actuellement en mode édition de profil. Cliquez ici pour revenir à la vue de votre profil.',
            position: 'bottom',
        },
    },
    {
        element: '.pe-content1',
        popover: {
            title: '📋 Formulaire d\'Édition',
            description: 'Ici vous trouverez tous les champs à remplir selon la section sélectionnée dans la barre latérale.',
            position: 'left',
        },
    },
    {
        element: '.pe-footer',
        popover: {
            title: '💾 Actions de Sauvegarde',
            description: 'Utilisez ces boutons pour annuler ou sauvegarder vos modifications.',
            position: 'top',
        },
    },
    {
        element: '.pe-discard',
        popover: {
            title: '❌ Annuler les Modifications',
            description: 'Cliquez ici pour annuler toutes vos modifications et revenir à la page précédente sans sauvegarder.',
            position: 'top',
        },
    },
    {
        element: '.pe-save',
        popover: {
            title: '✅ Sauvegarder les Modifications',
            description: 'Cliquez sur ce bouton pour enregistrer toutes vos modifications. Assurez-vous que toutes les informations sont correctes avant de sauvegarder.',
            position: 'top',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment modifier votre profil. N\'oubliez pas de sauvegarder vos modifications avant de quitter !',
            side: 'over',
        },
    },
];